// extracted by mini-css-extract-plugin
export default {"searchBarWrapper":"DebouncingSearchBar_searchBarWrapper__CM6ni","xButton":"DebouncingSearchBar_xButton__sgpE2"};